import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";

import Button from "../common/Button";

const Scheduler = () => {
  const appointmentRefs = useRef([]);

  const getDefaultAppointments = () => {
    return [
      {
        appointmentAt: "01:00",
        startTime: "01:00",
        endTime: "01:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
      {
        appointmentAt: "03:00",
        startTime: "03:00",
        endTime: "03:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
      {
        appointmentAt: "05:00",
        startTime: "05:00",
        endTime: "05:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },

      {
        appointmentAt: "07:00",
        startTime: "07:00",
        endTime: "07:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
      {
        appointmentAt: "08:00",
        startTime: "08:00",
        endTime: "08:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
      {
        appointmentAt: "09:30",
        startTime: "09:30",
        endTime: "10:00",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
      {
        appointmentAt: "12:00",
        startTime: "12:00",
        endTime: "12:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
      {
        appointmentAt: "15:00",
        startTime: "15:00",
        endTime: "15:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
      {
        appointmentAt: "18:00",
        startTime: "18:00",
        endTime: "18:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
      {
        appointmentAt: "21:00",
        startTime: "21:00",
        endTime: "21:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },

      {
        appointmentAt: "2:00",
        startTime: "23:00",
        endTime: "23:30",
        name: "Karen Cooper Thomas",
        appointmentFor: "Minor Ailment, virtual",
      },
    ];
  };

  const [appointments, setAppointments] = useState(getDefaultAppointments());

  const getFormattedDate = (date) => {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };
  const [date, setDate] = useState(getFormattedDate(new Date()));

  useEffect(() => {
    // Create an array representing each hour of the day in the format "HH:00"
    const hoursArray = Array.from({ length: 24 }, (_, hour) => {
      return `${hour}:00`;
    });

    // Get the current time
    const now = new Date();
    const currentHour = now.getHours();
    // const currentHour = 8;
    const currentMinutes = now.getMinutes();

    // Find the closest time in hoursArray to the current time (HH:MM)
    const closestTime = getClosestTime(
      hoursArray,
      `${currentHour}:${currentMinutes}`
    );

    // Find the index of the appointment that matches the closest time
    const currentAppointmentIndex = hoursArray.findIndex(
      (app) => app === closestTime
    );

    // If a matching appointment is found, scroll to that appointment element smoothly
    if (appointmentRefs.current[currentAppointmentIndex]) {
      appointmentRefs.current[currentAppointmentIndex].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [appointments]);

  const getTimeDifferenceInMinutes = (startTime, endTime) => {
    // Parse the time strings into Date objects
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    const [endHours, endMinutes] = endTime.split(":").map(Number);

    // Convert the time to minutes
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;

    // Calculate the difference in minutes
    return endTotalMinutes - startTotalMinutes;
  };

  const getClosestTime = (timeStrings, currentTimeStr) => {
    // Convert current time to minutes
    const currentTime = convertTimeToMinutes(currentTimeStr);

    // Initialize variables to store the closest time and the smallest difference
    let closestTime = timeStrings[0];
    let smallestDifference = Math.abs(
      currentTime - convertTimeToMinutes(closestTime)
    );

    // Iterate over the time strings to find the closest time
    timeStrings.forEach((time) => {
      const timeInMinutes = convertTimeToMinutes(time);
      const difference = Math.abs(currentTime - timeInMinutes);

      if (difference < smallestDifference) {
        smallestDifference = difference;
        closestTime = time;
      }
    });

    return closestTime;
  };

  const get12HourTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const amOrPm = hours >= 12 ? "pm" : "am";
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${minutes.toString().padStart(2, "0")} ${amOrPm}`;
  };

  const convertTimeToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const changeDate = (days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    setDate(getFormattedDate(newDate));
  };

  return (
    <div>
      <div className="flex justify-between items-center p-2 pb-4 rounded-md">
        {/* Date Display on the left */}
        <span className="text-lg font-semibold">{date}</span>

        {/* Arrows on the right */}
        <div className="flex space-x-2">
          <button
            onClick={() => changeDate(-1)}
            className="p-2 rounded-md focus:outline-none"
          >
            <ReactSVG src="/icons/arrow-left.svg" />
          </button>
          <button
            onClick={() => changeDate(1)}
            className="p-2 rounded-md focus:outline-none"
          >
            <ReactSVG src="/icons/Next.svg" />
          </button>
        </div>
      </div>
      {/* contnet */}
      <div className="max-h-screen overflow-y-scroll">
        {Array.from({ length: 24 }, (_, hour) => (
          <div
            key={hour}
            ref={(el) => (appointmentRefs.current[hour] = el)}
            className="grid grid-cols-12 relative"
          >
            {/* Time labels */}
            <div className="col-span-3 text-right pr-4 py-2">
              {get12HourTime(`${hour}:00`)}
            </div>
            {/* Gray background for appointments */}
            <div className="col-span-9 border-t border-l border-r border-gray-400 bg-gray-20 relative h-56">
              {/* Position the appointment within the correct time slot */}
              {appointments
                .filter(
                  (app) =>
                    parseInt(app.appointmentAt.split(":")[0], 10) === hour
                )
                .map((app, index) => {
                  const startTime = parseInt(app.startTime.split(":")[1], 10); // Get the minute part
                  const duration = getTimeDifferenceInMinutes(
                    app.startTime,
                    app.endTime
                  ); // Assuming all appointments are 30 minutes
                  const topPosition = (startTime / 60) * 100; // Calculate top position based on start time
                  const height = (duration / 60) * 100; // Calculate height based on duration

                  return (
                    <div
                      key={index}
                      className="absolute bg-white p-3 rounded-xl shadow-md border border-gray-400 w-11/12 ml-3 mt-2 z-10"
                      style={{ top: `${topPosition}%`, height: `${height}%` }}
                    >
                      <div className="text-sm font-bold text-gray-800">
                        {app.name}
                      </div>
                      <div className="text-xs text-gray-500">
                        {app.startTime}-{app.endTime}
                      </div>
                      <div className="text-xs text-gray-600">
                        {app.appointmentFor}
                      </div>
                      <div className="mt-2 flex space-x-2">
                        <Button
                          type="primary-outline"
                          text="Reschedule"
                          className="flex-grow w-full !px-2 !py-0.5 !text-xxs-body !rounded-2xl !font-normal"
                        />
                        <Button
                          type="primary"
                          text="Start Service"
                          className="flex-grow w-full !px-2 !py-0.5 !text-xxs-body !rounded-2xl !font-normal"
                        />
                      </div>

                      {/* <div className="mt-2 flex space-x-2">
                      <Button
                        type="primary-outline"
                        text="Reschedule"
                        className="!px-2 !py-0.5 !text-xxs-body !rounded-2xl !font-normal"
                      />
                      <Button
                        type="primary"
                        text="Start Service"
                        className="!px-2 !py-0.5 !text-xxs-body !rounded-2xl !font-normal"
                      />
                    </div> */}
                    </div>
                  );
                })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Scheduler;
